import { SVGProps } from 'react';

export const ChartIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3654 8.182C16.3654 4.12218 13.0616 0.818359 9.00178 0.818359H8.18359V9.00018H16.3654V8.182Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.54545 9.8191V2.50537L6.444 2.51846C2.77036 2.97746 0 6.11601 0 9.81828C0 13.8789 3.30382 17.1819 7.36364 17.1819C9.09 17.1819 10.7681 16.5724 12.0886 15.4629L12.1435 15.4171L6.54545 9.8191Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.47998 10.6372L15.2637 16.4226L15.843 15.8433C17.2339 14.4516 17.9997 12.6033 17.9997 10.6372H9.47998Z"
        fill="currentColor"
      />
    </svg>
  );
};
